// Mock data per Idromo Italia

export const mockServices = {
  idraulica: [
    {
      id: 1,
      title: "Impianti Idraulici",
      description: "Installazione e manutenzione di impianti idraulici per abitazioni civili e industriali",
      icon: "droplets"
    },
    {
      id: 2,
      title: "Irrigazione",
      description: "Progettazione e realizzazione di sistemi di irrigazione per giardini e aree verdi",
      icon: "sprout"
    },
    {
      id: 3,
      title: "Caldaie e Canne Fumarie",
      description: "Sostituzione caldaie, installazione e manutenzione canne fumarie a norma",
      icon: "flame"
    },
    {
      id: 4,
      title: "Pronto Intervento",
      description: "Servizio rapido 24/7 per emergenze idrauliche e perdite d'acqua",
      icon: "siren"
    }
  ],
  edilizia: [
    {
      id: 5,
      title: "Ristrutturazioni Complete",
      description: "Rifacimento totale di abitazioni con gestione completa del progetto",
      icon: "home"
    },
    {
      id: 6,
      title: "Ristrutturazione Bagni",
      description: "Rinnovamento completo di bagni con materiali di qualità",
      icon: "bath"
    },
    {
      id: 7,
      title: "Ristrutturazione Cucine",
      description: "Progettazione e realizzazione di cucine moderne e funzionali",
      icon: "utensils"
    },
    {
      id: 8,
      title: "Piccoli Lavori Edili",
      description: "Interventi edilizi mirati per migliorare la tua casa",
      icon: "hammer"
    }
  ]
};

export const mockReviews = [
  {
    id: 1,
    name: "Francesco Tosi",
    rating: 5,
    text: "Professionali e veloci! Hanno risolto la perdita d'acqua in pochissimo tempo. Consigliatissimi!",
    date: "2 settimane fa"
  },
  {
    id: 2,
    name: "Laura Ines",
    rating: 5,
    text: "Abbiamo ristrutturato il bagno con loro. Lavoro impeccabile, precisione nei dettagli e rispetto dei tempi.",
    date: "1 mese fa"
  },
  {
    id: 3,
    name: "Giuseppe Ferrari",
    rating: 5,
    text: "Ragazzi giovani ma molto competenti. Hanno sostituito la mia caldaia in giornata. Ottimo servizio!",
    date: "3 settimane fa"
  },
  {
    id: 4,
    name: "Chiara Moretti",
    rating: 5,
    text: "Ristrutturazione completa della cucina. Risultato fantastico, consiglio vivamente Idromo!",
    date: "2 mesi fa"
  }
];

export const mockStats = [
  { number: "500+", label: "Interventi Completati" },
  { number: "98%", label: "Clienti Soddisfatti" },
  { number: "24/7", label: "Pronto Intervento" },
  { number: "5★", label: "Recensioni Google" }
];

export const mockContact = {
  phone: "3514826210",
  email: "info@idromo.it",
  city: "Modena",
  workingHours: "Lun-Ven: 08:00-19:00 | Sab: Solo Urgenze | Dom: Riposo"
};

export const mockRegistrationOffer = {
  discount: "10€",
  freeVisit: "30€",
  title: "Sconto Primo Intervento",
  description: "Registrati ora e ricevi 10€ di sconto sul primo intervento + prima uscita gratuita (valore 30€)"
};
